import { render, staticRenderFns } from "./BusinessDetails.vue?vue&type=template&id=07610594&scoped=true&"
import script from "./BusinessDetails.vue?vue&type=script&lang=js&"
export * from "./BusinessDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07610594",
  null
  
)

export default component.exports